module.exports = __webpack_public_path__ + "img/f-8.jpg";